/**
 * Helpers: GraphQL
 * ------------------------------------------------------------------------------
 * - GraphQL related helpers.
 *
 */
/**
 * Converts GraphQL IDs to their Liquid format.
 * @param {String} string - Encoded string.
 * @returns {String}
 */
export function decodeApiId(string) {
  if (!string) {
    return null
  }

  return Number(string.split('/').pop())
}

/**
 * Removes edges and nodes from GraphQL data.
 * @param {Object} object - GraphQL data.
 * @param {String} field - Optional string to filter by.
 * @returns {Object}
 */
export function transformEdges(object, field) {
  if (field == null) {
    return object.edges.map((edge) => {
      return edge.node
    })

  } else {
    return object.edges.map((edge) => {
      return edge.node[field]
    })
  }
}